import { FC, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { DistributionChannelConnector, DistributionChannelContent } from '@/models/distributionChannels';
import { twMerge } from 'tailwind-merge';

interface AudienceConnectorsLinkMessageProps {
  audienceName: string;
  connectors: ReadonlyArray<{
    connector: DistributionChannelConnector;
    distributionChannelContent?: DistributionChannelContent;
  }>;
  classNames?: string;
}

export const AudienceConnectorsLinkMessage: FC<AudienceConnectorsLinkMessageProps> = ({ audienceName, connectors, classNames }) => {
  const connectorsName = useMemo(() => connectors.map((item) => item.connector.name).join(', '), [connectors]);

  return (
    <p className={twMerge(classNames)}>
      <Trans
        i18nKey='campaign:connectAudienceToDestinations'
        values={{
          audienceName,
          destinationsName: connectorsName,
        }}
        components={{
          strongBlue: <span className='font-bold text-brand-700' />,
        }}
      />
    </p>
  );
};
